import laravelPublicAxiosClient from "../laravelPublicAxiosClient";
import { CheckUserPayload, CheckUserResult } from "../interfaces/check-user.interface";
import laravelAxiosClient from "../laravelAxiosClient";
import { UpdateEmailPayload } from "../interfaces/update-email.interface";
import { UpdateSiretPayload } from "../interfaces/update-siret.interface";
import { AttestationsResult } from "../interfaces/attestations.interface";
import { CurrentUserResult } from "../interfaces/current-user.interface";
import { UpdateCoordonneesPayload } from "../interfaces/update-coordonnees.interface";
import { UpdatePreferencesCommunicationPayload } from "../interfaces/update-preferences-communication.interface";
import { UpdatePasswordPayload } from "../interfaces/update-password.interface";

export const findUser = async () => {
  const { data } = await laravelAxiosClient.get<CurrentUserResult>("/users/current-user");
  return data;
};

export const checkUser = async (payload: CheckUserPayload) => {
  const { data } = await laravelPublicAxiosClient.post<CheckUserResult>("/users/check-user", payload);
  return data;
};

export const findAllAttestations = async () => {
  const { data } = await laravelAxiosClient.get<AttestationsResult>("/users/attestations");
  return data;
};

export const updateSiret = async ({ userId, siret }: UpdateSiretPayload) => {
  const { data } = await laravelAxiosClient.post(`/users/${userId}/siret`, { siret });
  return data;
};

export const updateEmail = async (payload: UpdateEmailPayload) => {
  await laravelAxiosClient.post("/users/update-email", payload);
};

export const updateCoordonnees = async ({ userId, coordonnees }: UpdateCoordonneesPayload) => {
  const { data } = await laravelAxiosClient.patch(`/users/${userId}/coordonnees`, coordonnees);
  return data;
};

export const updatePreferencesCommunication = async (payload: UpdatePreferencesCommunicationPayload) => {
  await laravelAxiosClient.patch("/users/preferences-communication", payload);
};

export const updatePassword = async (payload: UpdatePasswordPayload) => {
  await laravelAxiosClient.post("/users/update-password", payload);
};
